import { createAction } from '@reduxjs/toolkit'
import { administrationClear } from 'redux/action.types'
import administrationReducer from './Administration.reducer'

export const clearAdministrationState = createAction(administrationClear)

export default administrationReducer
